"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendToRecepientResponseSerializer = exports.MessageSendPerformer = exports.SendabilityStatus = void 0;
const EngageActionPerformer_1 = require("./EngageActionPerformer");
const isRetryableError_1 = require("./isRetryableError");
const AggregateError_1 = require("./AggregateError");
const getProfileApiEndpoint_1 = require("./getProfileApiEndpoint");
const track_1 = require("./track");
const actions_core_1 = require("@segment/actions-core");
const ResponseError_1 = require("./ResponseError");
var SendabilityStatus;
(function (SendabilityStatus) {
    SendabilityStatus["ShouldSend"] = "should_send";
    SendabilityStatus["NotSubscribed"] = "not_subscribed";
    SendabilityStatus["NoSupportedExternalIds"] = "no_supported_ids";
    SendabilityStatus["InvalidSubscriptionStatus"] = "invalid_subscription_status";
    SendabilityStatus["SendDisabled"] = "send_disabled";
})(SendabilityStatus = exports.SendabilityStatus || (exports.SendabilityStatus = {}));
class MessageSendPerformer extends EngageActionPerformer_1.EngageActionPerformer {
    async sendToRecepientCache(recepient) {
        const messageId = this.getMessageId();
        const recipientId = recepient.id;
        if (!messageId || !recipientId)
            return this.sendToRecepient(recepient);
        return await this.getOrAddCache(`${messageId}-${recipientId?.toLowerCase()}`, () => this.sendToRecepient(recepient), {
            expiryInSeconds: 60 * 60 * 4,
            cacheGroup: 'sendToRecepient',
            lockOptions: {
                acquireLockMaxWaitTimeMs: 30 * 1000,
                acquireLockRetryIntervalMs: 1000,
                lockMaxTimeMs: (this.isLockExpirationExtended() ? 30 : 10) * 60000
            },
            serializer: exports.SendToRecepientResponseSerializer
        });
    }
    async doPerform() {
        const res = this.forAllRecepients(this.isFeatureActive('engage-cache-send-message')
            ? this.sendToRecepientCache.bind(this)
            : this.sendToRecepient.bind(this));
        if (this.executeInput.features) {
            this.logInfo('Feature flags:' + JSON.stringify(this.executeInput.features));
        }
        this.statsEventDeliveryTs();
        return res;
    }
    getStaticMembersOfThisClass() {
        return this.constructor;
    }
    isExternalIdSubscribed(extId) {
        const staticMems = this.getStaticMembersOfThisClass();
        const subStatus = extId.subscriptionStatus?.toString()?.toLowerCase();
        const isOptOutModel = this.payload.sendBasedOnOptOut ? true : false;
        if (!subStatus)
            return isOptOutModel;
        if (staticMems.sendableStatuses.includes(subStatus))
            return true;
        if (staticMems.nonSendableStatuses.includes(subStatus))
            return false;
        return undefined;
    }
    convertSubscriptionStatusText(subVal) {
        if (subVal == undefined) {
            return 'unknown';
        }
        if (subVal == '') {
            return 'did_not_subscribe';
        }
        return subVal;
    }
    getSendabilityPayload() {
        if (!this.payload.send) {
            return { sendabilityStatus: SendabilityStatus.SendDisabled };
        }
        const supportedExtIdsWithSub = this.payload.externalIds
            ?.filter((extId) => this.isSupportedExternalId(extId))
            .map((extId) => ({
            extId,
            isSubscribed: this.isExternalIdSubscribed(extId)
        }));
        this.payload.sendBasedOnOptOut
            ? this.currentOperation?.tags.push('SubscriptionOptOutType:' + true)
            : this.currentOperation?.tags.push('SubscriptionOptOutType:' + false);
        if (!supportedExtIdsWithSub || !supportedExtIdsWithSub.length)
            return {
                sendabilityStatus: SendabilityStatus.NoSupportedExternalIds
            };
        this.currentOperation?.tags.push('subscription_status:' + this.convertSubscriptionStatusText(supportedExtIdsWithSub[0]?.extId?.subscriptionStatus));
        const invalidSubStatuses = supportedExtIdsWithSub.filter((e) => e.isSubscribed === undefined).map((e) => e.extId);
        const shouldSendExtIds = supportedExtIdsWithSub.filter((e) => e.isSubscribed === true).map((e) => e.extId);
        if (!shouldSendExtIds.length) {
            return invalidSubStatuses.length == 0
                ? {
                    sendabilityStatus: SendabilityStatus.NotSubscribed
                }
                : {
                    sendabilityStatus: SendabilityStatus.InvalidSubscriptionStatus,
                    invalid: invalidSubStatuses
                };
        }
        if (shouldSendExtIds.length) {
            const subWithIds = shouldSendExtIds.filter((extId) => extId.id);
            return {
                sendabilityStatus: subWithIds.length > 0 ? SendabilityStatus.ShouldSend : SendabilityStatus.NoSupportedExternalIds,
                recepients: subWithIds.length > 0 ? subWithIds : shouldSendExtIds,
                invalid: invalidSubStatuses
            };
        }
        if (invalidSubStatuses.length)
            return {
                sendabilityStatus: SendabilityStatus.InvalidSubscriptionStatus,
                invalid: invalidSubStatuses
            };
        return {
            sendabilityStatus: SendabilityStatus.NoSupportedExternalIds,
            recepients: supportedExtIdsWithSub.map((e) => e.extId)
        };
    }
    getRecepients() {
        const sendabilityPayload = this.getSendabilityPayload();
        const shouldSend = sendabilityPayload.sendabilityStatus === SendabilityStatus.ShouldSend;
        this.currentOperation?.tags.push('sendability_status:' + sendabilityPayload.sendabilityStatus);
        this.currentOperation?.logs.push(shouldSend
            ? `Sending message to recepients (${sendabilityPayload.recepients?.length}): ${sendabilityPayload.recepients
                ?.map((r) => this.redactPii(r.id))
                .join(', ')}})`
            : `Not sending message because ${sendabilityPayload.sendabilityStatus?.toUpperCase()}. Recepients (${sendabilityPayload.recepients?.length})`);
        return sendabilityPayload.sendabilityStatus == SendabilityStatus.ShouldSend
            ? sendabilityPayload.recepients || []
            : [];
    }
    getCommonTags() {
        const settings = this.settings;
        const payload = this.payload;
        const res = [
            `space_id:${settings.spaceId}`,
            `projectid:${settings.sourceId}`,
            `settings_region:${settings.region}`,
            `channel:${this.getChannelType()}`
        ];
        const correlation_id = this.getCorrelationId();
        if (correlation_id)
            res.push(`correlation_id:${correlation_id}`);
        const computation_id = payload.segmentComputationId;
        if (computation_id)
            res.push(`computation_id:${computation_id}`);
        return res;
    }
    getCorrelationId() {
        return this.payload.customArgs?.correlation_id || this.payload.customArgs?.__segment_internal_correlation_id__;
    }
    getMessageId() {
        return this.executeInput['rawData']?.messageId;
    }
    beforePerform() {
        void super.beforePerform?.();
        if (this.executeInput.statsContext)
            this.executeInput.statsContext.tags = this.statsClient.mergeTags(this.executeInput.statsContext.tags, this.getCommonTags());
        if (!this.settings.region && this.getDefaultSettingsRegion) {
            this.settings.region = this.getDefaultSettingsRegion();
        }
        Object.assign(this.logDetails, {
            externalIds: this.payload.externalIds?.map((eid) => ({
                id: this.redactPii(eid.id),
                channelType: eid.channelType,
                subStatus: eid.subscriptionStatus,
                type: eid.type
            })),
            shouldSend: this.payload.send,
            settings_region: this.settings.region,
            sourceId: this.settings.sourceId,
            spaceId: this.settings.spaceId,
            messageId: this.getMessageId(),
            channelType: this.getChannelType()
        });
        if ('userId' in this.payload)
            this.logDetails.userId = this.payload.userId;
        if (this.executeInput.statsContext?.tags) {
            for (const item of this.executeInput.statsContext?.tags) {
                if (item.includes('delivery_attempt') || item.includes('replay')) {
                    this.logDetails[item.split(':')[0]] = item.split(':')[1];
                }
            }
        }
    }
    statsEventDeliveryTs() {
        const eventOccurredTS = this.payload?.eventOccurredTS;
        if (typeof eventOccurredTS === 'number') {
            this.statsHistogram('eventDeliveryTS', Date.now() - new Date(eventOccurredTS).getTime());
        }
    }
    async forAllRecepients(sendToRecepient) {
        const recepients = this.getRecepients();
        await this.beforeSend?.(recepients);
        const results = (await Promise.allSettled(recepients.map((recepient) => sendToRecepient(recepient)))).map((r, i) => ({
            recepient: recepients[i],
            status: r.status,
            ...(r.status === 'rejected' ? { error: r.reason } : { result: r.value })
        }));
        return this.aggregateSendResults(results);
    }
    aggregateSendResults(sendResults) {
        if (!sendResults.length) {
            return;
        }
        if (sendResults.length === 1) {
            const sendResult = sendResults[0];
            if (sendResult.status === 'rejected') {
                throw sendResult.error;
            }
            else {
                return sendResult.result;
            }
        }
        const rejected = sendResults.filter((sr) => sr.status === 'rejected');
        if (rejected.length) {
            const firstRetryableError = rejected.find((r) => (0, isRetryableError_1.isRetryableError)(r.error))?.error;
            throw AggregateError_1.AggregateError.create({
                errors: rejected.map((r) => r.error),
                takeCodeAndStatusFromError: firstRetryableError,
                message: (msg) => `Failed to send to all subscribed recepients (${firstRetryableError ? 'retryable' : 'not-retryable'}):` + msg
            });
        }
        return sendResults.map((sr) => sr.result);
    }
    async getProfileTraits() {
        if (this.payload.traitEnrichment)
            return this.payload?.traits || {};
        if (!this.payload.userId) {
            throw new actions_core_1.PayloadValidationError('No userId provided and no traits provided');
        }
        const endpoint = (0, getProfileApiEndpoint_1.getProfileApiEndpoint)(this.settings.profileApiEnvironment, this.settings.region);
        const encodedProfileId = encodeURIComponent(this.payload.userId);
        const response = await this.request(`${endpoint}/v1/spaces/${this.settings.spaceId}/collections/users/profiles/user_id:${encodedProfileId}/traits?limit=200`, {
            headers: {
                authorization: `Basic ${Buffer.from(this.settings.profileApiAccessToken + ':').toString('base64')}`,
                'content-type': 'application/json'
            }
        });
        const body = await response.json();
        return body.traits;
    }
}
MessageSendPerformer.nonSendableStatuses = ['unsubscribed', 'false'];
MessageSendPerformer.sendableStatuses = ['subscribed', 'true'];
__decorate([
    (0, track_1.track)()
], MessageSendPerformer.prototype, "sendToRecepientCache", null);
__decorate([
    (0, track_1.track)()
], MessageSendPerformer.prototype, "getProfileTraits", null);
exports.MessageSendPerformer = MessageSendPerformer;
exports.SendToRecepientResponseSerializer = {
    stringify: (cacheable) => {
        if (cacheable.error && (0, isRetryableError_1.isRetryableError)(cacheable.error))
            return;
        let cacheObj = undefined;
        if (cacheable.error) {
            const errorDetails = (0, ResponseError_1.getErrorDetails)(cacheable.error);
            cacheObj = { error: errorDetails };
        }
        else {
            cacheObj = { value: cacheable.value?.status };
        }
        return cacheObj ? JSON.stringify(cacheObj) : undefined;
    },
    parse: (cachedValue) => {
        const parsed = JSON.parse(cachedValue);
        if (parsed.error) {
            const error = new actions_core_1.IntegrationError(parsed.error.message, parsed.error.code, parsed.error.status);
            error.retry = false;
            return { error };
        }
        else {
            return { value: { status: parsed.value } };
        }
    }
};
//# sourceMappingURL=MessageSendPerformer.js.map